import fp from 'lodash/fp';


type ReturnType<TFunc> = TFunc extends (...args: any[]) => infer TReturn ? TReturn : any;
type ArgsType<TFunc> = TFunc extends (...args: infer TArgs) => any ? TArgs : any[];

export const tryInvoke = <TFunc>(
    func?: TFunc, ...args: ArgsType<TFunc>
): ReturnType<TFunc> | void => {
    if (fp.isFunction(func))
        return func(...args);
    return undefined;
};

export const delay = (milliseconds: number) =>
    new Promise<void>(resolve => setTimeout(resolve, milliseconds));

export const infiniteAsync = async (func: () => Promise<void>) => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // eslint-disable-next-line no-await-in-loop
        await func();
    }
};

type CookieValue = string | number | boolean;
const cookieLifetime = 30 * 86400;
export const getCookie = (name: string): CookieValue => {
    const matches = document.cookie.match(
        new RegExp(
            `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`,
        ),
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const setCookie = (
    name: string,
    value: CookieValue,
    lifeTime: number = cookieLifetime,
) => {
    document.cookie = `${encodeURIComponent(name)}=` +
        `${encodeURIComponent(value)}; max-age=${lifeTime}`;
};
